import type { HTMLOrSVGElement } from '../engine/types'

export function isHTMLOrSVG(el: Node): el is HTMLOrSVGElement {
  return el instanceof HTMLElement || el instanceof SVGElement
}

export function findClosestScoped(el: HTMLOrSVGElement | null): string | null {
  return (
    (el?.closest('[data-scoped]') as HTMLOrSVGElement | null)?.dataset
      .scoped ?? null
  )
}
